<template>
    <div>
        <div class="form-group">
            <div class="row">
                <div class="col-lg-4">
                    <map-autocomplete-single
                        label="Partenza"
                        ref="mapsAutocompleteFrom"
                        id="maps_autocomplete_from"
                        name="source_address"
                        latitude-name="source_lat"
                        longitude-name="source_lng"
                        @placeCleared="placeFromCleared"
                        @placeSelected="placeFromSelected"
                    />
                    <span class="small"
                        >Il prezzo stimato non include l'avvicinamento del
                        taxi</span
                    >
                </div>

                <div class="col-lg-4">
                    <map-autocomplete-single
                        label="Destinazione"
                        ref="mapsAutocompleteTo"
                        id="maps_autocomplete_to"
                        name="destination_address"
                        latitude-name="destination_lat"
                        longitude-name="destination_lng"
                        @placeCleared="placeToCleared"
                        @placeSelected="placeToSelected"
                    />
                </div>
                <div class="col-lg-2">
                    <form-select
                        label="Distanza"
                        id="distance_range"
                        name="distance_range"
                        :value="getValue('distance_range', 2)"
                        :options="distanceRange"
                        @selection-ready="selectionIsReady"
                    ></form-select>
                </div>
                <div class="col-lg-2 align-self-center">
                    <btn
                        type="primary"
                        block
                        :action="submitSearch"
                        title="Cerca"
                    ></btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        from: null,
        to: null,
        datas: {},
        rangeKm: ""
    }),
    props: {
        mapRef: {
            type: String,
            default: "",
            required: false
        },
        tableRef: {
            type: String,
            default: "",
            required: false
        },
        distanceRange: {
            type: Array,
            default: null,
            required: true
        }
    },
    computed: {},
    methods: {
        assignData: function(datas) {
            if (!datas) return false;

            if (!!Object.keys(datas).length) {
                this.datas = datas;
                if (!!datas.id) this.id = datas.id;
            } else {
                this.datas = {};
                this.id = "";
            }
        },
        getValue: function(key, defaultValue) {
            if (!!this.datas[key]){
                this.rangeKm = this.datas[key];
                return this.datas[key];
            }
            else if (!!defaultValue) {
                this.rangeKm = this.datas[key];
                return defaultValue;
            }
            else return "";
        },
        placeFromCleared: function(position) {
            this.from = null;
            this.placeCleared("from");
        },
        placeFromSelected: function(position) {
            this.placeSelected("from", position);
        },
        placeToCleared: function(position) {
            this.to = null;
            this.placeCleared("to");
        },
        placeToSelected: function(position) {
            this.placeSelected("to", position);
        },
        placeSelected: function(source, position) {
            this[source] = {
                address: position.address,
                formatted_address: position.formatted_address,
                lat: position.lat,
                lng: position.lng,
                range: distance_range.value
            };
            // if (!!this.mapRef) {
            //     this.$root.$refs[this.mapRef].addMarker(source, this[source]);
            // }
            this.$root.updateFilters(
                {
                    id: source + "_lat",
                    value: this[source].lat,
                },
                this.tableRef,
                this.mapRef
            );
            this.$root.updateFilters(
                {
                    id: source + "_lng",
                    value: this[source].lng
                },
                this.tableRef,
                this.mapRef
            );
            // this.$root.updateFilters(
            //     {
            //         id: source + "_range",
            //         value: this[source].range
            //     },
            //     this.tableRef,
            //     this.mapRef
            // );
        },
        placeCleared: function(source) {
            this.$root.removeFilters(source + "_lat", this.tableRef);
            this.$root.removeFilters(source + "_lng", this.tableRef);
        },
        onMapReady: function() {
            if (!!this.mapRef) {
            }
        },
        submitSearch: function() {
            if (!!this.from && !!this.to) {
                this.$root.submitSearchMap(this.mapRef);
            }
            this.$root.submitSearchTable(this.tableRef);
        },
        selectionIsReady: function() {
            var range = distance_range.value;
            this.$root.updateFilters(
                {
                    id: "range",
                    value: range
                },
                this.tableRef,
                this.mapRef
            );
        }
    },
    created: function() {},
    mounted: function() {}
};
</script>
